module.exports = __webpack_public_path__ + "img/plan2.aa3d75f5.png";